import { Component, Input, OnInit } from "@angular/core";
import { AttachmentModel } from "src/app/admin/models/attachment-model";
import {
  FranchiseDetail,
  GetFranchseSuspensionModel,
} from "src/app/admin/models/franchise-detail";
import { AttachmentTypes } from "src/app/franchise-app-global";
import { AttachmentService } from "src/app/services/AttachmentService";

@Component({
  selector: "app-cancelled-section",
  templateUrl: "./cancelled-section.component.html",
  styleUrls: ["./cancelled-section.component.scss"],
})
export class CancelledSectionComponent implements OnInit {
  @Input() franchise: FranchiseDetail;
  cancelAttachment: AttachmentModel | null = null;
  franchiseSuspension?: GetFranchseSuspensionModel;
  constructor(private attachmentService: AttachmentService) {}

  ngOnInit(): void {
    this.franchiseSuspension = this.franchise?.franchiseSuspension;
    let cancelAttacement = this.franchiseSuspension?.attachment;
    if (cancelAttacement) {
      this.cancelAttachment = cancelAttacement;
    } else {
      cancelAttacement = this.franchise.attachments.find(
        (attachment) =>
          attachment.attachmentTypeId === AttachmentTypes.CancelReason
      );
      if (cancelAttacement) this.cancelAttachment = cancelAttacement;
    }
  }

  downloadAttachment(publicId: string, fileName: string) {
    this.attachmentService.DownloadAdminFile(publicId, fileName);
  }
}
